export default __webpack_public_path__ + "static/media/BUDYNEKMAJ25.887fb31d.jpg";